import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import BreakTag from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyBreakConfigurations/Card/Tag'
import {
  TimeSettingsBreakConfigs,
  useFetchTimeSettingsBreakConfigurations,
} from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'
import BreakModal from 'modules/time_categories_settings/components/BreakConfigurations/BreakModal'
import CreateCustomBreakForm from 'modules/time_categories_settings/lib/forms/CreateCustomBreakForm'

interface Props {
  value: number
  onChange: (newValue: number) => void
  timeSettingsBreakConfigurations: TimeSettingsBreakConfigs[]
  attendanceSettingId: number
}

const BreakTypeSelector = ({
  value,
  onChange,
  attendanceSettingId,
  timeSettingsBreakConfigurations,
}: Props) => {
  const [open, setModalOpen] = React.useState(false)
  const { refetch, manageBreakConfigurations } =
    useFetchTimeSettingsBreakConfigurations(attendanceSettingId)

  let selectedBreakType = timeSettingsBreakConfigurations.find(
    (breakConfiguration) => breakConfiguration.id === Number(value)
  )

  const createBreakform = CreateCustomBreakForm({
    setModalOpen,
    onSuccess: (id) => {
      if (id) {
        refetch().then(() => {
          selectedBreakType = timeSettingsBreakConfigurations.find(
            (breakConfiguration) => breakConfiguration.id === Number(id)
          )
          onChange(Number(id))
        })
      }
    },
  })

  return (
    <Box gap="s6" flexDirection="column">
      <Text size="200" weight="medium" color="grey1000">
        {i18n.t('time_tracking.settings.breaks.instance.automatic_rules.breaks_selector.title')}
      </Text>
      <Box width="full">
        <Selector.Popover
          placeholder={i18n.t(
            'time_tracking.settings.breaks.instance.automatic_rules.breaks_selector.placeholder'
          )}
          searchPlaceholder={i18n.t('common.search')}
          blankLabel={i18n.t(
            'time_tracking.settings.breaks.instance.automatic_rules.breaks_selector.blank_label'
          )}
          value={selectedBreakType ? [selectedBreakType.id] : []}
          onChange={(newValue) => onChange(Number(newValue))}
          isMultiSelect={false}
          footer={
            manageBreakConfigurations && (
              <Box alignItems="flexStart">
                <Button type="secondary" iconName="add" onClick={() => setModalOpen(true)}>
                  {i18n.t('shift_management.saved_shifts.breaks_form.create')}
                </Button>
              </Box>
            )
          }
        >
          {timeSettingsBreakConfigurations.map((breakConfiguration: TimeSettingsBreakConfigs) => (
            <Selector.Option
              key={breakConfiguration.id}
              value={breakConfiguration.id}
              label={breakConfiguration.name}
              searchValue={breakConfiguration.name}
            >
              {breakConfiguration.name}
              <BreakTag paid={breakConfiguration.paid} />
            </Selector.Option>
          ))}
        </Selector.Popover>

        {open && <BreakModal setModalOpen={setModalOpen} form={createBreakform} />}
      </Box>
    </Box>
  )
}

export default BreakTypeSelector
